var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Text } from "../../";
/**
 *
 * @param {object} props
 * @param {import('./badgeVariants').BadgeVariant} [props.variant]
 * @param {React.ReactNode} props.children
 */
export default function Badge(_a) {
    var { variant = "default", children } = _a, rest = __rest(_a, ["variant", "children"]);
    return (_jsx(Text, Object.assign({ variant: "smallest", sx: {
            borderRadius: "round",
            display: "inline-block",
            paddingX: 2,
            marginRight: "auto",
            variant: `badge.${variant}`,
        } }, rest, { children: children })));
}
//# sourceMappingURL=Badge.js.map